import { connect } from 'react-redux'
import ContactForm from './ContactForm'
import showNumbersFormModal from 'features/Numbers/NumbersFormModal'

const mapStateToProps = () => ({})

const dispatchToProps = {
  showNumbersFormModal,
}

export default connect(mapStateToProps, dispatchToProps)(ContactForm)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/ContactForm/ContactForm.container.jsx